import type { GetStaticPaths, GetStaticProps, InferGetStaticPropsType } from 'next'
import { NextPageLayout } from '@/utils/types/getLayout'
import getPersonasLayout from '@/components/templates/menu/view/menuNuevo'
import { ListaSEOType } from '@/utils/types'
import { getListaSeoStaticProps } from '@/utils/listaSeo'
import { ListaSEOV1Layout } from '@/components/templates/listaSeoV1/ListaSEOV1Layout'
import { ListaSEOV2Layout } from '@/components/templates/listaSeoV2/ListaSEOV2Layout'

export const getStaticProps: GetStaticProps<ListaSEOType> = async (ctx) =>{
	const resp = await getListaSeoStaticProps(ctx, []);

	if(resp === undefined){
		return {
			notFound: true,
		}
	}

	return {
		props: {
			...resp,
		},
		revalidate: 600 // every 10 minutes check for new content
	};
}

export const getStaticPaths = (async () => {
	const pathList = [["venta"], ["arriendo"]]
	const paths = pathList.map(paths => (
		{
			params: {
				pathListaSeo: paths, // Array path of url /venta/casa/metropolitana/la-florida [ "venta", "casa", "metropolitana", "la-florida"]
			},
		}
	));

	return {
		paths: paths,
		fallback: "blocking",
	}
}) satisfies GetStaticPaths

const ListaSEO: NextPageLayout<InferGetStaticPropsType<typeof getStaticProps>> = (props: InferGetStaticPropsType<typeof getStaticProps>) => {
	if (props.layoutVersion === 'v2') {
		return <ListaSEOV2Layout {...props} />;
	}
	return <ListaSEOV1Layout {...props} />;
}

ListaSEO.getLayout = getPersonasLayout;
export default ListaSEO
